import { Mail } from 'lucide-react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import '../../styles/footer.css';

const SOCIALS = [
  { href: 'https://www.linkedin.com/in/ervin-tejada-a18239242', icon: FaLinkedin, label: 'LinkedIn' },
  { href: 'https://github.com/Nevriii',                          icon: FaGithub,   label: 'GitHub' },
  { href: 'mailto:ervintejada05@gmail.com',                     icon: Mail,       label: 'Email' },
];

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-inner">
        <p className="footer-copy">
          © {year} <span>Vin Tejada</span>. All rights reserved.
        </p>

        <div className="footer-socials" aria-label="Social links">
          {SOCIALS.map(({ href, icon: Icon, label }) => (
            <a
              key={label}
              href={href}
              target={href.startsWith('mailto') ? undefined : '_blank'}
              rel="noopener noreferrer"
              aria-label={label}
              title={label}
            >
              <Icon size={18} strokeWidth={1.8} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
